import type { MoneyAutomationCountryFeatureConfig } from './type';

export const moneyAutomationFeatureConfigSK: MoneyAutomationCountryFeatureConfig = {
    roundUpSavings: {
        localStoreProductUri: 'sporenie/?entryPoint=roundUp&offerId=@@offer_rep_id',
        useClientIdWithUnderscore: true,
    },
};
